import Api from '@/services/Api'
import { AppVersion, OS, PlatformName } from '../deviceDetails'

const logMixin = {
	computed: {
		position() {
			return this.$store.state.position
		},
		os() {
			return OS
		},
		appVersion() {
			return AppVersion
		}
	},
	methods: {
		generateDeviceId() {
			const existingId = localStorage.getItem('deviceId')
			if (existingId) {
				return existingId
			}

			// Generate a pseudo-unique ID (UUID)
			const deviceId = window.crypto.randomUUID()

			// Save in local storage for persistence
			localStorage.setItem('deviceId', deviceId)
			return deviceId
		},
		getDeviceLocation() {
			return new Promise((resolve, reject) => {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						(position) => {
							resolve({
								latitude: position.coords.latitude,
								longitude: position.coords.longitude
							})
						},
						(error) => {
							reject(error)
						}
					)
				} else {
					reject('Geolocation is not supported by this browser.')
				}
			})
		},
		async getIpAddress() {
			try {
				const response = await fetch('https://api.ipify.org?format=json')
				const data = await response.json()
				return data.ip
			} catch (error) {
				console.error('Error fetching IP address:', error)
				return null
			}
		},
		async enableLogsAPI(userId) {
			const ipAddress = await this.getIpAddress()
			const location = await this.getDeviceLocation().catch(() => null)
			const deviceId = await this.generateDeviceId()
			const data = {
				UserId: userId,
				platform: 'Web',
				deviceDetail: PlatformName,
				DeviceId: deviceId,
				appVersion: this.appVersion,
				IpAddress: ipAddress || '',
				ScreenName: this.$route.name,
				UserIdInt: parseInt(userId),
				Latitude: location ? location.latitude.toString() : '',
				Longitude: location ? location.longitude.toString() : '',
				DeviceLocation: location ? `${location.latitude}, ${location.longitude}` : ''
			}

			if (this.position.lat !== null) data['latitude'] = this.position.lat

			if (this.position.long !== null) data['longitude'] = this.position.long

			await Api().post('Log/AddUserLog', data)
		}
	}
}

export default logMixin
